import { customFetch } from '@/lib/api/fetcher'
import { queryOptions } from '@tanstack/react-query'
import type { MaterialIssueOut, PendingWO } from '../types'

/**
 * Queue of posted work orders that still have planned material to issue.
 *
 * Backend contract: `GET /api/storekeeping/pending/` →
 *   `[{ work_order_id, work_order_number, project_id, project_name,
 *      work_date, lines_count, remaining_qty }, ...]`
 *
 * `staleTime: 15s` mirrors the work-orders / transactions cadence — the
 * queue mutates whenever an admin posts a material issue.
 */
export const storekeepingPendingQuery = () =>
  queryOptions({
    queryKey: ['storekeeping', 'pending'] as const,
    queryFn: ({ signal }) => customFetch<PendingWO[]>('/api/storekeeping/pending/', { signal }),
    staleTime: 15_000,
  })

/**
 * Today's posted material-issue notes (Накладні на видачу).
 *
 * Backend contract: `GET /api/storekeeping/today/` → `MaterialIssueOut[]`
 * (already filtered by `posted_at::date == today` server-side).
 */
export const storekeepingTodayQuery = () =>
  queryOptions({
    queryKey: ['storekeeping', 'today'] as const,
    queryFn: ({ signal }) =>
      customFetch<MaterialIssueOut[]>('/api/storekeeping/today/', { signal }),
    staleTime: 15_000,
  })
